<template>
  <div class="record">
    <date-picker :date.sync="query.inTime" type="year-month" title="选择年月日">
      <template #right>
        <div class="invoice-parking-site flex align-center">
          <span class="text-cut invoice-parking-site-name" @click="changeCar">{{
            query.plateNum ? query.plateNum : '全部车牌'
          }}</span>
          <van-icon name="arrow-down" />
        </div>
        <div class="invoice-parking-site flex align-center">
          <span
            class="text-cut invoice-parking-site-name"
            @click="changeStatus"
            >{{ query.statusName }}</span
          >
          <van-icon name="arrow-down" />
        </div>
      </template>
    </date-picker>
    <lazy-load-list
      v-if="tokenIsUseful == 1"
      :getData="initData"
      :description="'暂无停车记录'"
      :query="query"
    >
      <template v-slot="slotData">
        <div class="record-list">
          <div
            class="record-list-item"
            v-for="(item, index) in slotData.dataList"
            :key="index"
          >
            <div class="record-item-header flex align-center justify-between">
              <p class="record-item-site">
                <span
                  v-if="item.type == 1"
                  style="color: #009af3; margin-right: 5px"
                  >路内</span
                >
                <span
                  v-else-if="item.type == 2"
                  style="color: #009af3; margin-right: 5px"
                  >路外</span
                >
                <!-- <span v-if="item.plateColor == 1" class="border blue"><span>蓝牌</span></span>
                <span v-else-if="item.plateColor == 2" class="border green"><span>绿牌</span></span>
                <span v-else-if="item.plateColor == 3" class="border yellow"><span>黄牌</span></span>
                <span v-else-if="item.plateColor == 4" class="border lin"><span>临牌</span></span>
                <span v-else-if="item.plateColor == 5" class="border black"><span>黑牌</span></span>
                <span v-else-if="item.plateColor == 6" class="border white"><span>白牌</span></span>
                <span v-else-if="item.plateColor == 7" class="border yellow-green"><span>黄绿</span></span> -->

                <span class="font-title">{{ item.plateNum }}</span>
              </p>
              <div
                class="payStatus"
                :class="[
                  item.payStatus == 1
                    ? 'unpaid'
                    : item.payStatus == 2
                    ? 'fee-free'
                    : item.payStatus == 3
                    ? 'paid'
                    : '',
                ]"
              ></div>
            </div>
            <div class="parkingPay-carInfo-content">
              <div class="carInfo-content-item flex align-center">
                <img
                  class="carInfo-content-item3"
                  src="@/assets/images/pay/parking.png"
                  alt=""
                />
                <p class="carInfo-content-item-title font-title">
                  {{ item.parkName }}
                </p>
              </div>

              <div class="carInfo-content-item flex align-center">
                <img
                  class="carInfo-content-item1"
                  src="@/assets/images/pay/parkingPay-long.png"
                  alt=""
                />
                <p class="carInfo-content-item-title">驶入时间</p>
                <p class="carInfo-content-item-value">{{ item.inTime }}</p>
              </div>
              <div class="carInfo-content-item flex align-center">
                <img
                  class="carInfo-content-item1"
                  src="@/assets/images/pay/parking-time.png"
                  alt=""
                />
                <p class="carInfo-content-item-title">停车时长</p>
                <p class="carInfo-content-item-value" style="color: #009af3">
                  {{ secondToMinute(item.parkingTime) }}分钟
                </p>
              </div>

              <div class="carInfo-content-item flex align-center">
                <img
                  class="carInfo-content-item1"
                  src="@/assets/images/pay/parkingPay-number.png"
                  alt=""
                />
                <p class="carInfo-content-item-title">停车费用</p>
                <p class="carInfo-content-item-cost">￥{{ item.consume }}</p>
              </div>
            </div>
            <div class="record-item-pay">
              <van-button
                plain
                class="record-item-pay-btn btn-detail"
                @click="detail(item)"
                >查看详情
              </van-button>
              <van-button
                v-if="item.payStatus == 1"
                class="record-item-pay-btn btn-bg"
                @click="payNow(item)"
                >立即缴费</van-button
              >
            </div>
          </div>
        </div>
      </template>
    </lazy-load-list>
    <van-action-sheet v-model="showCarPick">
      <div class="content">
        <van-picker
          title="选择车牌"
          show-toolbar
          value-key="plateNum"
          :columns="carList"
          @confirm="carOnConfirm"
          @cancel="onCancel"
          @change="parkingOnChange"
        />
      </div>
    </van-action-sheet>

    <van-action-sheet v-model="showStatusPick">
      <div class="content">
        <van-picker
          title="选择状态"
          show-toolbar
          value-key="name"
          :columns="statusList"
          @confirm="statusOnConfirm"
          @cancel="onCancel"
          @change="parkingOnChange"
        />
      </div>
    </van-action-sheet>
    <dialog-warn
      :show.sync="showDialogWarn"
      :isNeedCancelBtn="isNeedCancelBtn"
      @handleConfirm="goPaymentOrder"
      rightBtnText="前往"
      :content="content"
      @handleLeftBtn="goDetail(choseItem)"
    />
  </div>
</template>

<script>
import {
  listMyParkingRecord,
  listMyPlateNum,
  getSysConfig,
  listPlateNumBill,
} from '@/api/api';
import { secondToMinute, parseCarCode } from '@/libs/tools';
import LazyLoadList from '@/components/base/lazyLoadList/lazy-load-list.vue';
import DatePicker from '@/components/base/datePicker/date-picker.vue';
import WarningLogin from '@/components/base/warning-login.vue';
import DialogWarn from '@/components/base/dialog/dialogWarn.vue';
import { obj2Param } from '@/libs/tools';
import { mapGetters } from 'vuex';
import DialogBox from '@/components/base/dialog/iconDialog.js';

import { Picker } from 'vant';

export default {
  name: 'Record',
  components: {
    LazyLoadList,
    DatePicker,
    'van-picker': Picker,
    WarningLogin,
    DialogWarn,
  },
  computed: {
    ...mapGetters({ tokenIsUseful: 'tokenIsUseful' }),
  },
  data() {
    return {
      // showLogin: false,
      // loginFlag: false,
      query: {
        plateNum: '',
        inTime: '',
        payStatus: '',
        statusName: '全部状态',
        pageNum: 0,
        pageSize: 10,
      },
      showCarPick: false, //选择车牌
      showStatusPick: false, //选择状态
      dataList: [],
      statusList: [
        {
          type: '',
          name: '全部状态',
        },
        {
          type: 1,
          name: '未缴费',
        },
        {
          type: 2,
          name: '免缴费',
        },
        {
          type: 3,
          name: '已缴费',
        },
      ],
      carList: [], //用户绑定的车牌

      showDialogWarn: false, //欠缴弹窗展示参数
      content: '尊敬的车主，您的车辆苏R66666有3笔订单未缴清，请前往缴费。',
      arrearsPlateNum: '', //欠费车牌
      arrearsPlateColor: '', //欠费车牌颜色
      choseItem: {}, //选择的订单
      isNeedCancelBtn: true, //是否强制缴费 强制则没有取消按钮
    };
  },
  mounted() {
    if (!this.tokenIsUseful) return;
    if (localStorage.getItem('userId')) {
      this.loginFlag = true;
      this.getListMyPlateNum();
      return;
    } else {
      this.showLogin = true;
    }
  },
  methods: {
    parseCarCode,
    secondToMinute,
    experience() {
      wx.miniProgram.redirectTo({
        url: `/pages/login/login?type=loginout`,
      });
    },
    //获取停车记录列表
    async initData() {
      const res = await listMyParkingRecord(this.query);
      if (!res.data && res.msg) {
        // 车辆未认证，弹框提示
        DialogBox({
          type: 'fail',
          content: `<div>${res.msg || 'error'}</div> `,
          leftBtnText: '',
          rightBtnText: '去认证',
          rightBtnClick: () => {
            this.$router.push('/mycar');
          },
        });
        return res;
      } else {
        return res;
      }
    },
    //获取车牌
    getListMyPlateNum() {
      listMyPlateNum().then((res) => {
        let arr = [
          {
            plateNum: '全部车牌',
          },
        ];
        this.carList = [...arr, ...res.data];
      });
    },
    //缴费
    async payNow(item) {
      if (item.type == 2) {
        let { plateNum, plateColor, parkCode } = item;
        // openOnroadMode 1强制 2关闭 3提醒
        let openOnroadMode = await getSysConfig({ parkCode }).then(
          (res) => res.data.openOnroadMode,
        );
        //2关闭 时不去请求
        let data =
          openOnroadMode != 2
            ? await listPlateNumBill({ plateNum, plateColor, payType: 4 }).then(
                (res) => res.data,
              )
            : [];
        //判断用户当前车牌是否有欠费
        if (data.total > 0) {
          //1强制不需要取消按钮
          if (openOnroadMode == 1) {
            this.showDialogWarn = true;
            this.isNeedCancelBtn = false;
          }
          // 3提醒 需要关闭取消按钮
          else if (openOnroadMode == 3) {
            this.showDialogWarn = true;
            this.isNeedCancelBtn = true;
          }

          this.content = `尊敬的车主，您的车辆${plateNum}有${data.total}笔订单未缴清，请前往缴费。`;
          this.arrearsPlateNum = plateNum;
          this.arrearsPlateColor = plateColor;
          this.choseItem = item;
          return;
        }
      }

      this.goDetail(item);
    },

    //支付
    goDetail(item) {
      let obj = {
        parkingRecordId: item.parkingRecordId,
        parkType: item.type,
        // needPay: item.consume,
        payStatus: 1,
      };

      this.$router.push({ name: 'ParkingPay', query: obj });
    },
    //跳转到详情
    detail(item) {
      let obj = {
        parkingRecordId: item.parkingRecordId,
        parkType: item.type,
        payStatus: item.payStatus,
      };
      this.$router.push({
        name: 'RecordDetail',
        params: obj,
      });
    },
    //唤起选择车牌界面
    changeCar() {
      this.showCarPick = true;
    },

    //唤起选择状态界面
    changeStatus() {
      this.showStatusPick = true;
    },

    //车牌选择确认
    carOnConfirm(value) {
      this.query.plateNum = value.plateNum == '全部车牌' ? '' : value.plateNum;
      this.showCarPick = false;
    },
    //状态选择确认
    statusOnConfirm(value) {
      this.query.payStatus = value.type;
      this.query.statusName = value.name;

      this.showStatusPick = false;
    },
    //弹窗选择取消
    onCancel() {
      this.showStatusPick = false;
      this.showCarPick = false;
    },
    parkingOnChange(value) {},
    goPaymentOrder() {
      if (localStorage.getItem('userId')) {
        let obj = {
          token: localStorage.getItem('token'),
          userId: localStorage.getItem('userId'),
          xcxOpenId: localStorage.getItem('openId'),
          plateNum: this.choseItem.plateNum,
        };
        let str = `${
          process.env.VUE_APP_BASE_API
        }qginsideparking/page/plateNumBill?${obj2Param(obj)}`;
        wx.miniProgram.navigateTo({
          url: `/pages/tab2/webview/webview?jumpUrl=${encodeURIComponent(str)}`,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.font-title {
  font-family: 'PingFangSC';
  font-size: 32px;
  // font-weight: bold;
}

.record {
  padding-bottom: 100px;

  .record-list {
    margin-top: 100px;
    padding: 16px 24px;

    .record-list-item {
      width: 702px;
      border-radius: 16px;
      background-color: #fff;
      margin-bottom: 16px;

      .record-item-header {
        width: 100%;
        height: 73px;
        padding: 0 0 0 30px;
        border-bottom: 1px solid #dbdada;

        .payStatus {
          width: 120px;
          height: 46px;
          margin-right: -6px;
        }

        .fee-free {
          background: url('~@/assets/images/pay/fee-free.png') no-repeat;
          background-size: 100% 100%;
        }

        .unpaid {
          background: url('~@/assets/images/pay/unpaid.png') no-repeat;
          background-size: 100% 100%;
        }

        .paid {
          background: url('~@/assets/images/pay/paid.png') no-repeat;
          background-size: 100% 100%;
        }

        .record-item-site {
          .border {
            margin-right: 10px;
            display: inline-flex;
            justify-content: center;
            line-height: 30px;
            color: #fff;
            width: 60px;
            height: 30px;

            border-radius: 10px;

            span {
              display: inline-block;
              font-size: 14px;
              transform: scale(0.83, 0.83);
            }
          }

          .blue {
            background-color: #009af3;
            border: 1px #009af3 solid;
          }

          .green {
            background-color: #19c228;
            border: 1px #19c228 solid;
          }

          .yellow {
            background-color: #ffbf02;
            border: 1px #ffbf02 solid;
          }

          .lin {
            background-color: #bddced;
            border: 1px #000 solid;
            color: #000;
          }

          .black {
            background-color: #000;
            border: 1px #000 solid;
          }

          .white {
            color: #000;
            background-color: #fff;
            border: 1px #000 solid;
          }

          .yellow-green {
            color: #19c228;

            background-color: #ffbf02;
            border: 1px #19c228 solid;
          }

          color: #333333;
        }

        .record-item-status {
          font-size: 30px;
        }

        .color-gray {
          color: #999;
        }

        .color-red {
          color: #f96161;
        }
      }

      .parkingPay-carInfo-content {
        flex: 1;
        padding: 24px 44px 27px;

        .carInfo-content-header {
          font-size: 32px;
          font-weight: 500;
          color: #212121;
          margin-bottom: 30px;
        }

        .carInfo-content-item {
          margin-bottom: 16px;

          .carInfo-content-item1 {
            width: 24px;
            height: 24px;
          }

          .carInfo-content-item2 {
            width: 24px;
            height: 28px;
          }

          .carInfo-content-item3 {
            width: 32px;
            width: 28px;
          }

          .carInfo-content-item-title {
            margin-left: 17px;
            vertical-align: top;
          }

          .carInfo-content-item-value {
            margin-left: auto;
            color: #666666;
          }

          .carInfo-content-item-cost {
            margin-left: auto;

            color: #ff8b19;
          }
        }
      }

      .record-item-pay {
        padding: 0 30px 30px;
        text-align: right;

        .record-item-pay-btn {
          width: 160px;
          height: 48px;
          white-space: nowrap;
          border-radius: 10px;
        }

        .btn-bg {
          color: #fff;
          margin-left: 20px;
          background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
        }

        .btn-detail {
          color: #009af3;
          border: 1px #00c6ea solid;
        }
      }
    }
  }
}

.invoice-parking-site {
  margin-right: 10px;
  font-size: 28px;
  color: #666666;

  .invoice-parking-site-name {
    width: 137px;
    text-align: center;
  }
}
</style>
